import { SxProps, Theme } from '@mui/material';

export const staticSliderSX: SxProps<Theme> = (theme: Theme) => ({
	'.MuiCard-root': {
		maxWidth: '370px',
		minWidth: '240px',
		marginRight: '40px',
		[theme.breakpoints.down('lg')]: {
			marginRight: '15px',
		},
	},
});
